module.exports = __webpack_public_path__ + "img/11-1_05.9c470732.jpg";